import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';
import { Form } from '@unform/web';
import { isArray, isUndefined, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';
import * as Yup from 'yup';

import { Spinner, Accordion, SelectDataInTable } from '~/components';
import { Input, Select, Autocomplete, Hidden } from '~/components/Form';
import {
  TELEMETRIA,
  DESCARGA_TERMINAL,
  CUSTOMIZACAO_RAIZEN,
  MODULO_FERROVIA,
  MOTORISTA_ABASTECIMENTO,
  MODULO_CONSULTA_TOTALIZADOR,
} from '~/constants/modules';
import { t, can } from '~/helpers';
import api from '~/services/api';
import {
  storeTerminal,
  updateTerminal,
} from '~/store/modules/terminal/actions';

import * as S from './styles';
import { Container } from './styles';

function normalizeTipoRecebimentoTerminal(value) {
  if (value === 1 || value === '1') return 'G';
  if (value === 0 || value === '0' || !value) return 'N';

  return value;
}

export default function CreateOrUpdate({
  reference,
  data,
  create,
  toggleLoading,
  toggleConfirmButton,
}) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector((state) => state.terminal);
  const [controlaTelemetriaTerminal, setControlaTelemetriaTerminal] = useState(
    create ? 'N' : { ...find, ...data }.controlatelemetriaterminal
  );
  const [tipoRecebimentoTerminal, setTipoRecebimentoTerminal] = useState('N');
  const [isComboio, setIsComboio] = useState(false);
  const [lc, setLc] = useState(0);
  const [postoscomboios, setPostosComboios] = useState([]);
  const [postoscomboiosadicionais, setPostosComboiosAdicionais] = useState([]);
  const [varTipoconcentrador, setVarTipoconcentrador] = useState(0);
  const [
    varTipoConcentradorModoRede,
    setVarTipoConcentradorModoRede,
  ] = useState(undefined);
  const [
    VarControlelinhaabastecimentoterminal,
    setVarControlelinhaabastecimentoterminal,
  ] = useState(() =>
    create
      ? 0
      : Number({ ...find, ...data }.controlelinhaabastecimentoterminal || 0)
  ); // Default sem controle de vazao
  const [checkTipoTerminal, setCheckTipoTerminal] = useState(() =>
    create ? 9 : Number({ ...find, ...data }.tipoterminal || 9)
  );
  const [leitorInternoTerminal, setLeitorInternoTerminal] = useState(() =>
    create ? 0 : Number({ ...find, ...data }.leitorinternoterminal || 0)
  );
  const [formatosRfidLimpados, setFormatosRfidLimpados] = useState(false);
  const [pendingRequests, setPendingRequests] = useState(0);
  const [hasLoadingError, setHasLoadingError] = useState(false);
  const loadingErrorMessage = 's.geral.loadingerror';

  const handleAsyncLoadingChange = useCallback(
    (isLoading) => {
      setPendingRequests((state) => {
        if (hasLoadingError) return 0;

        if (isLoading) return state + 1;

        return state > 0 ? state - 1 : 0;
      });
    },
    [hasLoadingError]
  );

  const handleAsyncLoadingError = useCallback(() => {
    setHasLoadingError(true);
    setPendingRequests(0);
  }, []);

  useEffect(() => {
    toggleLoading(pendingRequests > 0);
  }, [pendingRequests, toggleLoading]);

  useEffect(() => {
    toggleConfirmButton(!hasLoadingError);
  }, [hasLoadingError, toggleConfirmButton]);

  useEffect(
    () => () => {
      toggleLoading(false);
      toggleConfirmButton(true);
    },
    [toggleLoading, toggleConfirmButton]
  );

  const statusInativeActive = [
    { label: t('s.geral.opcoes.nao'), value: 0 },
    { label: t('s.geral.opcoes.sim'), value: 1 },
  ];

  const statusSimNao = [
    { label: t('s.geral.opcoes.nao'), value: 'N' },
    { label: t('s.geral.opcoes.sim'), value: 'S' },
  ];

  const tiporecebimentoterminal = [
    { label: t('s.geral.opcoes.nao'), value: 'N' },
    {
      label: t('s.configuracao.terminal.offlinetiporecebimentoterminal'),
      value: 'G',
    },
  ];

  const statusConcentrador = [
    { label: t('s.geral.opcoes.semconcentrador'), value: 0 },
    { label: 'CBC', value: 1 },
    { label: 'Horustech', value: 2 },
    { label: 'Concentradora Abastek', value: 3 },
  ];

  const tipohorustech = [
    { label: 'Padrão - TCA direto', value: 0 },
    { label: 'Servidor - TCA mestre do posto', value: 1 },
    { label: 'Cliente - TCA cliente do TCA mestre', value: 2 },
  ];

  const tipoTerminal = useMemo(
    () => [
      { label: 'BOPLA', value: 0 },
      { label: 'TCA3XX', value: 3 },
      { label: 'TLA', value: 5 },
    ],
    []
  );

  const tipoTerminalComFerrovia = useMemo(
    () => [
      { label: 'BOPLA', value: 0 },
      { label: 'TCA3XX', value: 3 },
      { label: 'TCA3XX_FERROVIA', value: 4 },
      { label: 'TLA', value: 5 },
    ],
    []
  );

  const leitoresInterno = [
    { label: t('s.geral.opcoes.nao'), value: 0 },
    { label: 'Micro Reader', value: 1 },
    { label: 'Quantum IS 3480', value: 2 },
    { label: 'Akiyama CI05 ', value: 3 },
    { label: 'RFIDCC RFEasy ', value: 4 },
    { label: 'Abastek Híbrido ', value: 5 },
    { label: 'HID', value: 6 },
  ];

  const formatosLeituraRfid13MHz = [
    { label: 'Wiegand W2 (Hexa)', value: 0 },
    { label: 'Wiegand W0 (Hexa)', value: 1 },
    { label: 'Wiegand W1 (Hexa)', value: 2 },
    { label: 'Wiegand w0 (inverso W2)', value: 3 },
    { label: 'Abatrack A0 (10 dígitos)', value: 4 },
    { label: 'Abatrack A0 (14 dígitos)', value: 5 },
    { label: 'Abatrack A1 (14 dígitos)', value: 6 },
    { label: 'Abatrack A2 (14 dígitos)', value: 7 },
    { label: 'Wiegand W0 (Decimal)', value: 8 },
    { label: 'Wiegand W1 (Decimal)', value: 9 },
  ];

  const formatosLeituraRfid125KHz = [
    { label: 'Wiegand 34 (S)', value: 0 },
    { label: 'Wiegand 26 (W)', value: 1 },
    { label: 'Abatrack 10 (H)', value: 2 },
    { label: 'Abastrack 14 (A)', value: 3 },
  ];

  const usoimpressora = [
    { label: 'Não imprime', value: 0 },
    {
      label: 'Impressão interna sem pergunta - vias do banco de dados',
      value: 1,
    },
    {
      label: 'Impressão interna com pergunta - vias do banco de dados',
      value: 2,
    },
    {
      label: 'Impressão pelo software sem pergunta - vias igual a zero',
      value: 3,
    },
    {
      label: 'Impressão pelo sotwtare com pergunta - vias igual a zero',
      value: 4,
    },
    { label: 'Impressora no servidor de impressão', value: 5 },
    { label: 'Impressora Diebold', value: 6 },
    { label: 'Impressora Thermofip', value: 7 },
    { label: 'Impressora Xiamen MPT 725', value: 8 },
    { label: 'Impressora Elgin i9', value: 9 },
    { label: 'Impressora Bematech MP-4200 TH', value: 10 },
  ];

  const tipoimpressora = [
    { label: 'Próprio', value: 1 },
    { label: 'Terceiro', value: 2 },
    { label: 'Próprio + terceiro', value: 3 },
    { label: 'Comboio', value: 4 },
    { label: 'Próprio + comboio', value: 5 },
    { label: 'Terceiro + comboio', value: 6 },
    { label: 'Próprio + terceiro + comboio', value: 7 },
    { label: 'Compartimento', value: 8 },
    { label: 'Próprio + compartimento', value: 9 },
    { label: 'Terceiro + compartimento', value: 10 },
    { label: 'Próprio + terceiro + compartimento', value: 11 },
    { label: 'Comboio + compartimento', value: 12 },
    { label: 'Próprio + comboio + compartimento', value: 13 },
    { label: 'Terceiro + comboio + compartimento', value: 14 },
    { label: 'Próprio + terceiro + comboio + compartimento', value: 15 },
  ];

  const valoresControleLinhaAbastecimentoTerminal = [
    {
      label: t('s.geral.controlelinhaabastecimentoterminal.semcontrole'),
      value: 0,
    },
    { label: t('s.geral.controlelinhaabastecimentoterminal.remoto'), value: 1 },
    { label: t('s.geral.controlelinhaabastecimentoterminal.local'), value: 2 },
  ];

  const controlaTelemetria = [
    { label: t('s.geral.opcoes.nao'), value: 'N' },
    {
      label: t('s.geral.controlelinhaabastecimentoterminal.local'),
      value: 'L',
    },
    {
      label: t('s.geral.controlelinhaabastecimentoterminal.remoto'),
      value: 'R',
    },
  ];

  const cells = useMemo(
    () => [
      {
        id: 'idposto',
        label: t('s.geral.postocomboio'),
        format: (value) =>
          isEmpty(postoscomboios)
            ? ''
            : postoscomboios.find((val) => val.value === value).label,
      },
    ],
    [postoscomboios]
  );

  const schemaValidate = useMemo(
    () => ({
      idposto: Yup.number()
        .test(
          'Item existe na lista',
          t('s.cadastro.veiculo.existecomboiocommesmocodigo'),
          (value) => !postoscomboiosadicionais.some((p) => p.idposto == value)
        )
        .test(
          'Item igual',
          t('s.cadastro.veiculo.existecomboiocommesmocodigo'),
          (value) => !(initials.idposto == value)
        )
        .required(t('s.geral.validacao.campoobrigatorio')),
    }),
    [postoscomboiosadicionais]
  );

  const isFields = useMemo(
    () => [
      {
        id: 'idposto',
        label: t('s.geral.postocomboio'),
        type: 'autocomplete',
        option: {
          url: 'postoscomboios',
          unique: 'idposto',
          label: 'codigonomeposto',
        },
      },
    ],
    []
  );

  const accordionPostosComboiosAdicionais = useMemo(
    () => [
      {
        id: 'postocomboiosadicionais',
        title: t('s.geral.postocomboioadicionais'),
        isVisible: can(CUSTOMIZACAO_RAIZEN),
        component: () => (
          <SelectDataInTable
            icons={false}
            checkbox={false}
            showPagination={false}
            paginate={99999}
            size="small"
            variant="contained"
            position="row"
            unique="idposto"
            onChanged={(value) => setPostosComboiosAdicionais(value)}
            maxWidth="xs"
            noUpdate
            initials={postoscomboiosadicionais}
            fields={isFields}
            schema={schemaValidate}
            sendWhenEditing
            ignoreExtra={[{ idposto: initials.idposto }]}
            cells={cells}
            titleModal={t('s.geral.postocomboio')}
          />
        ),
      },
    ],
    [postoscomboios, schemaValidate]
  );

  const initials = useMemo(() => {
    const initialData = create
      ? {
        ...data,
        pedepredeterminacaoterminal: 0,
        controlelinhaabastecimentoterminal: 0,
        leitorsolinftecterminal: 0,
        tagrfid13mhzconfigterminal: 0,
        tagrfid125khzconfigterminal: 0,
        testtodasconfigrfidterminal: 0,
        solicitavalorNFrecebimentoterminal: 'S',
        exigetagfimliberaterminal: 'N',
      }
      : { ...find, ...data };

    return {
      ...initialData,
      tiporecebimentoterminal: normalizeTipoRecebimentoTerminal(
        initialData.tiporecebimentoterminal
      ),
    };
  }, [create, data, find]);

  function handleControlaTelemetriaTerminal(value) {
    reference.current?.setFieldValue('controlatelemetriaterminal', value);
    setControlaTelemetriaTerminal(value);
  }

  function handleTipoRecebimentoTerminal(value) {
    setTipoRecebimentoTerminal(normalizeTipoRecebimentoTerminal(value));
  }

  function handleLeitorInternoTerminal(value) {
    const nextValue = Number(value);
    reference.current?.setFieldValue('leitorinternoterminal', nextValue);
    setLeitorInternoTerminal(nextValue);

    if (nextValue !== 5) {
      reference.current?.setFieldValue('tagrfid13mhzconfigterminal', '');
      reference.current?.setFieldValue('tagrfid125khzconfigterminal', '');
      reference.current?.setFieldValue('testtodasconfigrfidterminal', 0);
      setFormatosRfidLimpados(true);
    }
  }

  async function handleLC(value) {
    const nextValue = Number(value);
    await reference.current.setFieldValue('controlalcterminal', nextValue);
    await setLc(nextValue);
  }

  async function handleTipoConcentradorModoRede(value) {
    const nextValue = Number(value);
    await reference.current.setFieldValue(
      'tipoconcentradormodorede',
      nextValue
    );
    await setVarTipoConcentradorModoRede(nextValue);
  }

  function handleTipoTerminal(value) {
    const nextValue = Number(value);
    reference.current.setFieldValue('tipoterminal', nextValue);
    setCheckTipoTerminal(nextValue);
    if (nextValue !== 4) {
      // Só tem controle de vazão o terminal ferroviário
      reference.current.setFieldValue('controlelinhaabastecimentoterminal', 0);
      setVarControlelinhaabastecimentoterminal(0); // Sem controle
    }
  }

  async function handleTipoconcentrador(value) {
    const nextValue = Number(value);
    await reference.current.setFieldValue('tipoconcentrador', nextValue);
    await setVarTipoconcentrador(nextValue);

    if (varTipoconcentrador === 1 && nextValue === 2) {
      // CBC e Horustech
      await reference.current.setFieldValue('tipoconcentradormodorede', 0);
      await setVarTipoConcentradorModoRede(0);
    }
  }

  const handleGetPostosComboios = useCallback(async () => {
    try {
      handleAsyncLoadingChange(true);
      const response = await api.get('postoscomboios', {
        params: {
          pagesize: 9999,
          orderfield: 'codigonomeposto',
          ordination: 'asc',
          pesquisalista: true,
        },
        paramsSerializer: (param) => qs.stringify(param),
      });

      setPostosComboios(
        response.data.items.map((item) => ({
          value: item.idposto,
          label: item.codigonomeposto,
        }))
      );
    } catch (err) {
      handleAsyncLoadingError();
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      handleAsyncLoadingChange(false);
    }
  }, [handleAsyncLoadingChange, handleAsyncLoadingError]);

  async function handleControlelinhaabastecimentoterminal(value) {
    const nextValue = Number(value);
    await reference.current.setFieldValue(
      'controlelinhaabastecimentoterminal',
      nextValue
    );
    await setVarControlelinhaabastecimentoterminal(nextValue);
  }

  async function handleSubmit(param) {
    try {
      if (hasLoadingError) {
        toast.error(t(loadingErrorMessage));
        return;
      }

      if (pendingRequests > 0) {
        toast.warning(t('s.geral.validacao.aguardecarregamento'));
        return;
      }

      const nextControlaTelemetriaTerminal =
        can(TELEMETRIA) && !isComboio
          ? controlaTelemetriaTerminal ??
          param.controlatelemetriaterminal ??
          'N'
          : 'N';
      const nextTipoRecebimentoTerminal =
        normalizeTipoRecebimentoTerminal(
          param.tiporecebimentoterminal ?? tipoRecebimentoTerminal
        );
      const nextLc = Number(param.controlalcterminal ?? lc ?? 0);
      const nextTipoTerminal = Number(param.tipoterminal ?? checkTipoTerminal);
      const nextTipoConcentrador = Number(
        param.tipoconcentrador ?? varTipoconcentrador ?? 0
      );
      const nextTipoConcentradorModoRede = Number(
        param.tipoconcentradormodorede ?? varTipoConcentradorModoRede ?? 0
      );
      const nextControleLinhaAbastecimento = Number(
        param.controlelinhaabastecimentoterminal ??
        VarControlelinhaabastecimentoterminal ??
        0
      );
      const nextLeitorInternoTerminal = Number(
        param.leitorinternoterminal ?? leitorInternoTerminal ?? 0
      );
      const normalizedParam = {
        ...param,
        controlatelemetriaterminal: nextControlaTelemetriaTerminal,
        tiporecebimentoterminal: nextTipoRecebimentoTerminal,
        controlalcterminal: nextLc,
        tipoterminal: nextTipoTerminal,
        tipoconcentrador: nextTipoConcentrador,
        tipoconcentradormodorede: nextTipoConcentradorModoRede,
        controlelinhaabastecimentoterminal: nextControleLinhaAbastecimento,
        leitorinternoterminal: nextLeitorInternoTerminal,
        tagrfid13mhzconfigterminal:
          nextLeitorInternoTerminal === 5
            ? param.tagrfid13mhzconfigterminal ?? ''
            : 0,
        tagrfid125khzconfigterminal:
          nextLeitorInternoTerminal === 5
            ? param.tagrfid125khzconfigterminal ?? ''
            : 0,
        testtodasconfigrfidterminal:
          nextLeitorInternoTerminal === 5
            ? param.testtodasconfigrfidterminal ?? 0
            : 0,
      };

      const schema = Yup.object().shape({
        idterminal: can(CUSTOMIZACAO_RAIZEN)
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
          : Yup.string().nullable(),

        exibemotoristaterminal:
          checkTipoTerminal === 3 && can(MOTORISTA_ABASTECIMENTO)
            ? Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),

        idposto: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10)),

        duassaidasbicoterminal: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),

        portaterminal: !create
          ? Yup.number('Informe um número.')
            .typeError('Informe um número.')
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(1, t('s.geral.validacao.valorminimo').replace('%s', 1))
            .max(
              65535,
              t('s.geral.validacao.valormaximo').replace('%s', 65535)
            )
          : Yup.string().nullable(),

        tipoterminal: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),

        controlatelemetriaterminal:
          can(TELEMETRIA) && !isComboio
            ? Yup.string()
              .nullable()
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),

        ipcbcterminal:
          varTipoconcentrador > 0 && varTipoconcentrador < 3
            ? Yup.string()
              .nullable()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .max(20, t('s.geral.validacao.tamanhomaximo').replace('%s', 20))
            : Yup.string().nullable(),

        portacbcterminal:
          varTipoconcentrador > 0 && varTipoconcentrador < 3
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .max(
                65535,
                t('s.geral.validacao.valormaximo').replace('%s', 65535)
              )
            : Yup.string(),

        controlalcterminal: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),

        tiporecebimentoterminal: can(DESCARGA_TERMINAL)
          ? Yup.string()
            .nullable()
            .required(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),

        solicitacnpjdistrecebimentoterminal:
          tipoRecebimentoTerminal !== 'N' && can(DESCARGA_TERMINAL)
            ? Yup.string()
              .nullable()
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),

        solicitacnpjtransprecebimentoterminal:
          tipoRecebimentoTerminal !== 'N' && can(DESCARGA_TERMINAL)
            ? Yup.string()
              .nullable()
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),

        solicitaplacactrecebimentoterminal:
          tipoRecebimentoTerminal !== 'N' && can(DESCARGA_TERMINAL)
            ? Yup.string()
              .nullable()
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),

        solicitavalorNFrecebimentoterminal:
          tipoRecebimentoTerminal !== 'N' && can(DESCARGA_TERMINAL)
            ? Yup.string()
              .nullable()
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),

        exigetagfimliberaterminal: Yup.string()
          .nullable()
          .required(t('s.geral.validacao.campoobrigatorio')),

        iplcterminal:
          lc === 1
            ? Yup.string()
              .nullable()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .max(20, t('s.geral.validacao.tamanhomaximo').replace('%s', 20))
            : Yup.string(),

        portalcterminal:
          lc === 1
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .max(
                65535,
                t('s.geral.validacao.valormaximo').replace('%s', 65535)
              )
            : Yup.string(),

        enderecors485terminal:
          lc === 1
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .max(
                65535,
                t('s.geral.validacao.valormaximo').replace('%s', 65535)
              )
            : Yup.string(),

        leitorinternoterminal: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),

        tagrfid13mhzconfigterminal:
          nextLeitorInternoTerminal === 5
            ? Yup.number()
              .transform((value, originalValue) =>
                originalValue === '' ? undefined : value
              )
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number(),

        tagrfid125khzconfigterminal:
          nextLeitorInternoTerminal === 5
            ? Yup.number()
              .transform((value, originalValue) =>
                originalValue === '' ? undefined : value
              )
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number(),

        testtodasconfigrfidterminal:
          nextLeitorInternoTerminal === 5
            ? Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number(),

        leitorsolinftecterminal:
          can(MODULO_CONSULTA_TOTALIZADOR)
            ? Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number(),

        tipoconcentrador: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),

        pedepredeterminacaoterminal: Yup.number(),

        tipoconcentradormodorede:
          varTipoconcentrador === 2
            ? Yup.string()
              .nullable()
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),

        usaimpressoraterminal: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),

        viasimpressaoterminal: Yup.number()
          .typeError('Informe um número.')
          .required(t('s.geral.validacao.campoobrigatorio')),

        tipoimpressaoveiculoterminal: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),

        controlelinhaabastecimentoterminal:
          checkTipoTerminal == 4
            ? Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number(),

        hostcontrolevazaoterminal:
          VarControlelinhaabastecimentoterminal == 1
            ? Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),

        portacontrolevazaoterminal:
          VarControlelinhaabastecimentoterminal == 1
            ? Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number(),
      });

      await schema.validate(normalizedParam, {
        abortEarly: false,
      });

      const objSend = {
        exibemotoristaterminal: 0,
        exibemotoristatransferenciaterminal: 0,

        idterminal: '',
        ipterminal: null,
        dataultimaconexaoterminal: null,
        tempoverificacomandoterminal: 60,
        tempoverificaconexaoterminal: 30,
        versaofirmwareterminal: '',
        modeloterminal: '',
        geralogterminal: 0,
        usaimpressoraterminal: 0,
        viasimpressaoterminal: 0,
        tipoimpressaoveiculoterminal: 15,
        ipimpressoraremotaterminal: null,
        portaimpressoraremotaterminal: 0,
        ipcbcterminal: null,
        portacbcterminal: 0,
        iplcterminal: null,
        portalcterminal: 0,
        enderecors485terminal: 0,
        contadorconexaoterminal: 10,
        timeoutconnectterminal: 15,
        timeoutreceiveterminal: 30,
        timeoutextreceiveterminal: 30,
        pedepercentualtanqueterminal: 0,
        leitorinternoterminal: 0,
        tagrfid13mhzconfigterminal: 0,
        tagrfid125khzconfigterminal: 0,
        testtodasconfigrfidterminal: 0,
        exigetagfimliberaterminal: 'N',
        leitorsolinftecterminal: 0,
        controlatelemetriaterminal: 'N',
        geralogcomunicacaoterminal: 0,
        hostappsondaterminal: null,
        portappsondaterminal: 3000,
        portaterminal: 8081,
        tipoconcentradormodorede: 0,
        tipoconcentrador: 0,
        leitordlocterminal: 0,
        sinalbypassterminal: 0,
        ididioma: 'pt-br',
        ...initials,
        ...normalizedParam,
        idcliente: client,
        pedepredeterminacaoterminal:
          nextTipoTerminal === 3
            ? normalizedParam.pedepredeterminacaoterminal
            : 0,
        controlalcterminal: nextLc,
        controlatelemetriaterminal: nextControlaTelemetriaTerminal,
        tipoterminal: nextTipoTerminal,
        tiporecebimentoterminal: nextTipoRecebimentoTerminal,
        postoscomboiosadicionais: postoscomboiosadicionais.map(
          (pocoadicional) => ({
            ...pocoadicional,
            idterminal: '',
            idcliente: client,
          })
        ),
        registramedicaotelemetriaterminal:
          isComboio || nextControlaTelemetriaTerminal === 'L'
            ? normalizedParam.registramedicaotelemetriaterminal
            : 0,
        tipoconcentrador: nextTipoConcentrador,
        tipoconcentradormodorede:
          nextTipoConcentrador === 2 ? nextTipoConcentradorModoRede : 0,
        controlelinhaabastecimentoterminal:
          nextTipoTerminal === 4 ? nextControleLinhaAbastecimento : 0,
        hostcontrolevazaoterminal:
          nextTipoTerminal === 4
            ? nextControleLinhaAbastecimento === 1
              ? normalizedParam.hostcontrolevazaoterminal
              : ''
            : '',
        portacontrolevazaoterminal:
          nextTipoTerminal === 4
            ? nextControleLinhaAbastecimento === 1
              ? normalizedParam.portacontrolevazaoterminal
              : 0
            : 0,
        tagrfid13mhzconfigterminal:
          nextLeitorInternoTerminal === 5
            ? Number(normalizedParam.tagrfid13mhzconfigterminal)
            : 0,
        tagrfid125khzconfigterminal:
          nextLeitorInternoTerminal === 5
            ? Number(normalizedParam.tagrfid125khzconfigterminal)
            : 0,
        testtodasconfigrfidterminal:
          nextLeitorInternoTerminal === 5
            ? Number(normalizedParam.testtodasconfigrfidterminal)
            : 0,
      };

      if (create) {
        await dispatch(storeTerminal(objSend, params));
      } else {
        await dispatch(updateTerminal(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current?.setData(initials);
      setLeitorInternoTerminal(Number(initials.leitorinternoterminal || 0));
    }
  }, [loading, initials]);

  useEffect(() => {
    const {
      controlalcterminal,
      tiporecebimentoterminal,
      tipoterminal,
      tipoconcentrador,
      tipoconcentradormodorede,
      controlelinhaabastecimentoterminal,
      controlatelemetriaterminal,
    } = { ...find, ...data };

    if (!isUndefined(controlalcterminal) && controlalcterminal > 0) {
      setLc(1);
    }

    if (!isUndefined(tiporecebimentoterminal)) {
      setTipoRecebimentoTerminal(
        normalizeTipoRecebimentoTerminal(tiporecebimentoterminal)
      );
    }

    if (!isUndefined(tipoterminal)) {
      setCheckTipoTerminal(Number(tipoterminal));
    }

    if (!isUndefined(tipoconcentrador)) {
      setVarTipoconcentrador(Number(tipoconcentrador));
    }

    if (!isUndefined(tipoconcentradormodorede)) {
      setVarTipoConcentradorModoRede(Number(tipoconcentradormodorede));
    }

    if (!isUndefined(controlelinhaabastecimentoterminal)) {
      setVarControlelinhaabastecimentoterminal(
        Number(controlelinhaabastecimentoterminal)
      );
    }

    if (!isUndefined(controlatelemetriaterminal)) {
      setControlaTelemetriaTerminal(controlatelemetriaterminal);
    }
  }, [find, data]);

  useEffect(() => {
    if (can(CUSTOMIZACAO_RAIZEN)) {
      handleGetPostosComboios();
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(find) && !create) {
      if (find.postoscomboiosadicionais)
        setPostosComboiosAdicionais(find.postoscomboiosadicionais);
    }
  }, [find, create]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : hasLoadingError ? (
        <div
          style={{
            border: '1px solid #f5c6cb',
            background: '#f8d7da',
            color: '#721c24',
            borderRadius: '4px',
            padding: '16px',
            lineHeight: 1.5,
          }}
        >
          {t(loadingErrorMessage)}
        </div>
      ) : (
        <div style={{ position: 'relative', minHeight: '14rem' }}>
          <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
            {(!create || can(CUSTOMIZACAO_RAIZEN)) && (
              <Input
                name="idterminal"
                label={t('s.configuracao.terminal.idterminal')}
                disabled={!create}
              />
            )}

            <Autocomplete
              name="idposto"
              label="codigonomeposto"
              url="postoscomboios"
              unique="idposto"
              title={t('s.geral.postocomboio')}
              getValue={(value) => {
                setIsComboio(value.tipoposto === 'C');
              }}
              disabled={!create}
              onLoadingChange={handleAsyncLoadingChange}
              onLoadingError={handleAsyncLoadingError}
            />

            <Select
              name="duassaidasbicoterminal"
              label={t('s.configuracao.terminal.duassaidasbicoterminal')}
              options={statusInativeActive}
            />

            <Select
              name="tipoterminal"
              label={t('s.configuracao.terminal.tipoterminal')}
              options={
                can(MODULO_FERROVIA) ? tipoTerminalComFerrovia : tipoTerminal
              }
              onChange={({ target }) => {
                handleTipoTerminal(target.value);
              }}
            />

            {can(MODULO_FERROVIA) && checkTipoTerminal == 4 && (
              <>
                <Select
                  name="pedepercentualtanqueterminal"
                  label={t('s.geral.pedepercentualtanqueterminal')}
                  options={statusInativeActive}
                  defaultValue={
                    create ? '0' : initials.pedepercentualtanqueterminal
                  }
                />

                <Select
                  name="leitordlocterminal"
                  label={t('s.geral.leitordloc')}
                  options={statusInativeActive}
                  defaultValue={create ? '0' : initials.leitordlocterminal}
                />

                <Select
                  name="sinalbypassterminal"
                  label={t('s.geral.sinalbypassterminal')}
                  options={statusInativeActive}
                  defaultValue={create ? '0' : initials.sinalbypassterminal}
                />

                <Select
                  name="controlelinhaabastecimentoterminal"
                  label={t(
                    's.cadastro.terminal.controlelinhaabastecimentoterminal'
                  )}
                  options={valoresControleLinhaAbastecimentoTerminal}
                  defaultValue={
                    create ? '0' : initials.controlelinhaabastecimentoterminal
                  }
                  onChange={({ target }) => {
                    handleControlelinhaabastecimentoterminal(target.value);
                  }}
                />

                {VarControlelinhaabastecimentoterminal === 1 && (
                  <>
                    <Input
                      name="hostcontrolevazaoterminal"
                      label={t('s.cadastro.terminal.hostcontrolevazaoterminal')}
                      type="text"
                    />

                    <Input
                      name="portacontrolevazaoterminal"
                      label={t(
                        's.cadastro.terminal.portacontrolevazaoterminal'
                      )}
                      type="number"
                    />
                  </>
                )}
              </>
            )}

            {!create && (
              <Input
                name="portaterminal"
                label={t('s.configuracao.terminal.portaterminal')}
                type="number"
              />
            )}

            {can(TELEMETRIA) && !isComboio && (
              <Select
                name="controlatelemetriaterminal"
                label={t('s.configuracao.terminal.telemetriaterminal')}
                options={controlaTelemetria}
                getValue={handleControlaTelemetriaTerminal}
              />
            )}

            {can(TELEMETRIA) &&
              (isComboio || controlaTelemetriaTerminal === 'L') && (
                <>
                  <Select
                    name="registramedicaotelemetriaterminal"
                    label={t(
                      's.configuracao.terminal.registramedicaotelemetriaterminal'
                    )}
                    options={statusInativeActive}
                    defaultValue={
                      create ? '0' : initials.registramedicaotelemetriaterminal
                    }
                  />
                </>
              )}

            {can(DESCARGA_TERMINAL) && (
              <Select
                name="tiporecebimentoterminal"
                label={t('s.configuracao.terminal.tiporecebimentoterminal')}
                options={tiporecebimentoterminal}
                getValue={handleTipoRecebimentoTerminal}
              />
            )}

            {tipoRecebimentoTerminal !== 'N' && can(DESCARGA_TERMINAL) && (
              <>
                <Select
                  name="solicitacnpjdistrecebimentoterminal"
                  label={t(
                    's.configuracao.terminal.solicitacnpjdistrecebimentoterminal'
                  )}
                  options={statusSimNao}
                />

                <Select
                  name="solicitacnpjtransprecebimentoterminal"
                  label={t(
                    's.configuracao.terminal.solicitacnpjtransprecebimentoterminal'
                  )}
                  options={statusSimNao}
                />

                <Select
                  name="solicitaplacactrecebimentoterminal"
                  label={t(
                    's.configuracao.terminal.solicitaplacactrecebimentoterminal'
                  )}
                  options={statusSimNao}
                />

                <Select
                  name="solicitavalorNFrecebimentoterminal"
                  label={t(
                    's.configuracao.terminal.solicitavalorNFrecebimentoterminal'
                  )}
                  options={statusSimNao}
                />
              </>
            )}

            <Select
              name="tipoconcentrador"
              label={t('s.configuracao.terminal.tipoconcentrador')}
              options={statusConcentrador}
              onChange={({ target }) => {
                handleTipoconcentrador(target.value);
              }}
            />

            {varTipoconcentrador === 2 && (
              <Select
                name="tipoconcentradormodorede"
                label={t('s.configuracao.terminal.tipoconcentradormodorede')}
                options={tipohorustech}
                onChange={({ target }) => {
                  handleTipoConcentradorModoRede(target.value);
                }}
                defaultValue={
                  !create ? initials.tipoconcentradormodorede || 0 : undefined
                }
              />
            )}

            {varTipoconcentrador !== 2 && (
              <Hidden name="tipoconcentradormodorede" value="0" />
            )}

            {(varTipoconcentrador === 0 || varTipoconcentrador === 3) && (
              <>
                <Hidden name="ipcbcterminal" value="" />
                <Hidden name="portacbcterminal" value="0" />
              </>
            )}

            {varTipoconcentrador !== 0 && varTipoconcentrador !== 3 && (
              <>
                <Input
                  name="ipcbcterminal"
                  label={
                    varTipoConcentradorModoRede !== 2
                      ? t('s.configuracao.terminal.ipcbcterminal')
                      : 'IP rede TCA Servidor local'
                  }
                />

                {varTipoConcentradorModoRede !== 2 && (
                  <Input
                    name="portacbcterminal"
                    label={t('s.configuracao.terminal.portacbcterminal')}
                    type="number"
                  />
                )}

                {varTipoConcentradorModoRede === 2 && (
                  <Hidden name="portacbcterminal" value="0" />
                )}
              </>
            )}

            <Select
              name="controlalcterminal"
              label={t('s.configuracao.terminal.controlalcterminal')}
              options={statusInativeActive}
              onChange={({ target }) => handleLC(target.value)}
            />

            {lc > 0 && (
              <>
                <Input
                  name="iplcterminal"
                  label={t('s.configuracao.terminal.iplcterminal')}
                />

                <Input
                  name="portalcterminal"
                  label={t('s.configuracao.terminal.portalcterminal')}
                  type="number"
                />

                <Input
                  name="enderecors485terminal"
                  label={t('s.configuracao.terminal.enderecors485terminal')}
                  type="number"
                />
              </>
            )}

            <Select
              name="leitorinternoterminal"
              label={t('s.configuracao.terminal.leitorinternoterminal')}
              options={leitoresInterno}
              getValue={handleLeitorInternoTerminal}
            />

            {leitorInternoTerminal === 5 && (
              <>
                <Select
                  name="tagrfid13mhzconfigterminal"
                  label="Formato 13.56 Mhz"
                  options={formatosLeituraRfid13MHz}
                  initialValue={formatosRfidLimpados ? '' : null}
                  defaultValue={
                    create ? '0' : initials.tagrfid13mhzconfigterminal
                  }
                />
                <Select
                  name="tagrfid125khzconfigterminal"
                  label="Formato 125KHz"
                  options={formatosLeituraRfid125KHz}
                  initialValue={formatosRfidLimpados ? '' : null}
                  defaultValue={
                    create ? '0' : initials.tagrfid125khzconfigterminal
                  }
                />
                <Select
                  name="testtodasconfigrfidterminal"
                  label="Testar todas as configurações"
                  options={statusInativeActive}
                  defaultValue={
                    create ? '0' : initials.testtodasconfigrfidterminal
                  }
                />
              </>
            )}

            <Select
              name="exigetagfimliberaterminal"
              label={t('s.configuracao.terminal.exigetagfimliberaterminal')}
              options={statusSimNao}
            />

            {can(MODULO_CONSULTA_TOTALIZADOR) && (
              <Select
                name="leitorsolinftecterminal"
                label={t('s.configuracao.terminal.leitorsolinftecterminal')}
                options={statusInativeActive}
              />
            )}

            {checkTipoTerminal === 3 &&
              can(MOTORISTA_ABASTECIMENTO) &&
              !can(CUSTOMIZACAO_RAIZEN) && (
                <Select
                  name="exibemotoristaterminal"
                  label={t('s.cadastro.terminal.exibemotoristaterminal')}
                  options={[
                    { value: 0, label: 'Não solicita motorista' },
                    {
                      value: 1,
                      label: 'Solicita apenas o código para qualquer veículo',
                    },
                    {
                      value: 2,
                      label: 'Solicita código e senha para qualquer veículo',
                    },
                    {
                      value: 3,
                      label: 'Solicita apenas o código para veículos próprios',
                    },
                    {
                      value: 4,
                      label: 'Solicita código e senha para veículos próprios',
                    },
                    {
                      value: 5,
                      label: 'Solicita apenas o código para veículos terceiros',
                    },
                    {
                      value: 6,
                      label: 'Solicita código e senha para veículos terceiros',
                    },
                    {
                      value: 7,
                      label: 'Solicita código conforme cadastro empresa',
                    },
                    {
                      value: 8,
                      label:
                        'Solicita código e senha conforme cadastro empresa',
                    },
                  ]}
                />
              )}

            {checkTipoTerminal === 3 &&
              can(MOTORISTA_ABASTECIMENTO) &&
              can(CUSTOMIZACAO_RAIZEN) && (
                <Select
                  name="exibemotoristaterminal"
                  label={t('s.cadastro.terminal.exibemotoristaterminal')}
                  options={[
                    {
                      value: 0,
                      label: 'Não solicita motorista',
                    },
                    {
                      value: 1,
                      label: 'Solicita apenas o código para qualquer veículo',
                    },
                    {
                      value: 2,
                      label: 'Solicita código e senha para qualquer veículo',
                    },
                    {
                      value: 7,
                      label: 'Solicita código conforme cadastro empresa',
                    },
                    {
                      value: 8,
                      label:
                        'Solicita código e senha conforme cadastro empresa',
                    },
                  ]}
                />
              )}

            {checkTipoTerminal === 3 && can(MOTORISTA_ABASTECIMENTO) && (
              <Select
                name="exibemotoristatransferenciaterminal"
                label={t(
                  's.cadastro.terminal.exibemotoristatransferenciaterminal'
                )}
                options={[
                  {
                    value: 0,
                    label: 'Não solicita motorista',
                  },
                  {
                    value: 1,
                    label: 'Solicita motorista',
                  },
                ]}
              />
            )}

            {checkTipoTerminal === 3 && (
              <Select
                name="pedepredeterminacaoterminal"
                label={t(
                  's.geral.camposistema.volumepredeterminadomovimentacao'
                )}
                options={statusInativeActive}
              />
            )}

            <ExpansionPanelSummary
              aria-controls="panel5a-content"
              id="panel5a-header"
              style={{
                background: 'rgba(0, 0, 0, 0.05)',
                borderBottom: '1px solid rgba(0,0,0,.2)',
              }}
            >
              <Typography>Impressora</Typography>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails>
              <Container>
                <Select
                  name="usaimpressoraterminal"
                  label={t('s.configuracao.terminal.usaimpressoraterminal')}
                  options={usoimpressora}
                />
                <Input
                  name="viasimpressaoterminal"
                  label={t('s.configuracao.terminal.viasimpressaoterminal')}
                  type="number"
                />
                <Select
                  name="tipoimpressaoveiculoterminal"
                  label={t(
                    's.configuracao.terminal.tipoimpressaoveiculoterminal'
                  )}
                  options={tipoimpressora}
                />
              </Container>
            </ExpansionPanelDetails>
          </Form>
          <Spinner loading={pendingRequests > 0} />
        </div>
      )}

      {can(CUSTOMIZACAO_RAIZEN) && (
        <S.Wrapper>
          <Accordion accordions={accordionPostosComboiosAdicionais} />
        </S.Wrapper>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  toggleLoading: PropTypes.func,
  toggleConfirmButton: PropTypes.func,
};

CreateOrUpdate.defaultProps = {
  data: {},
  toggleLoading: () => { },
  toggleConfirmButton: () => { },
};
